import React, { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import NewsRequests from "services/news";
import GridContainer from "@jumbo/components/GridContainer";
import { Box, Grid } from "@material-ui/core";
import BlogElement from "./BlogElement";
import { Pagination } from "@material-ui/lab";
import { animateScroll as scroll } from "react-scroll";

const AllBlogs = () => {
  const { allBlogs, blogsTotalPages, blogsCurrentPage } = useSelector(
    ({ news }) => news
  );
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(NewsRequests.getAllBlogs(1));
  }, []);
  const handleChangePagination = (_, value) => {
    dispatch(NewsRequests.getAllBlogs(value));
    scroll.scrollToTop();
  };

  return (
    <>
      <GridContainer>
        <Grid item xs={12}>
          {allBlogs &&
            allBlogs.map((blog) => <BlogElement key={blog._id} blog={blog} />)}
        </Grid>
      </GridContainer>
      <Box display={"flex"} justifyContent={"center"} marginTop={"20px"}>
        <Pagination
          count={blogsTotalPages}
          color="primary"
          page={blogsCurrentPage}
          onChange={handleChangePagination}
        />
      </Box>
    </>
  );
};

export default AllBlogs;
